import React, { useState } from 'react'
import Layout from 'shared/layouts/containers/Main'
import { Row } from 'react-bootstrap'
import { Button, Card, CardBody, CardFooter, CardHeader, Col } from 'reactstrap'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import { iconStyle } from 'shared/consts'
import { IonIcon } from '@ionic/react'
import { download } from 'ionicons/icons'


const Manual: React.FunctionComponent = () => {
    return (
        <Layout
            footerContent={<Footer />}
            brandContent={getBrandContent()}
            showOverlay={false}
            headerInsert={
                <Button
                    type='submit'
                    name='save'
                    className='btn-round btn-primary'
                    onClick={() => {
                        const a = document.createElement("a");
                        a.href = 'pdf/manual.pdf';
                        a.download = '';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }}
                >
                    <IonIcon icon={download} className='ionicon' style={{
                        color: iconStyle.colorActive,
                        fontSize: 18,
                        marginTop: '-4px',
                        verticalAlign: 'middle'
                    }} />
                    Download
                </Button>
            }
        >
            <div>
                <iframe
                    className='text-center'
                    src='/pdf/manual.pdf'
                    style={{ width: '100%', minHeight: '650px', height: '100%' }}
                ></iframe>
            </div>
        </Layout>
    )
}

export default Manual
